import React, { useEffect, useState } from "react";
import { Drawer, Form, notification, Icon } from "antd";
import axios from "axios";

import UploadAnexo from "../../../../shared/components/Form/UploadAnexo";

import { FILE_SIZE } from "../../../../shared/utils/constants";
import { use } from "react";

const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description
    });
};

const DrawerBuscaAtiva = ({ visible, code, form, onClose, onConfirm }) => {
    const [declaracao, setDeclaracao] = useState([]);
    const [ata, setAta] = useState([]);
    const [declaracaoOriginal, setDeclaracaoOriginal] = useState(null);
    const [ataOriginal, setAtaOriginal] = useState(null);
    const [loading, setLoading] = useState(false);

    const limparEstados = () => {
        setDeclaracao([]);
        setAta([]);
        setDeclaracaoOriginal(null);
        setAtaOriginal(null);
    };

    const urlToFile = async (url, filename, mimeType = "application/pdf") => {
        const response = await fetch(url);
        const blob = await response.blob();

        return new File([blob], filename, { type: mimeType });
    };

    const detalhe = () => {
        axios({
            method: "get",
            url: "/api/aproveitamento/carregar-busca-ativa",
            params: {
                turmaId: localStorage.getItem("codigo_curso"),
                code: code
            }
        })
            .then(async response => {
                const documentos = response.data;

                for (const doc of documentos) {
                    const file = await urlToFile(doc.url, doc.nome);

                    if (doc.tipo === 9) {
                        setDeclaracao([file]);
                        setDeclaracaoOriginal({
                            name: file.name,
                            size: file.size,
                            lastModified: file.lastModified
                        });
                    } else if (doc.tipo === 10) {
                        setAta([file]);
                        setAtaOriginal({
                            name: file.name,
                            size: file.size,
                            lastModified: file.lastModified
                        });
                    }
                }
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", "Ocorreu um erro.");
            });
    };

    const ficheiroFoiAlterado = (ficheiroAtual, ficheiroOriginal) => {
        if (!ficheiroAtual) return false;

        if (!ficheiroOriginal) return true;

        return (
            ficheiroAtual.name !== ficheiroOriginal.name ||
            ficheiroAtual.size !== ficheiroOriginal.size ||
            ficheiroAtual.lastModified !== ficheiroOriginal.lastModified
        );
    };

    const existemAlteracoes = () => {
        const declaracaoAtual = declaracao.length > 0 ? declaracao[0] : null;
        const ataAtual = ata.length > 0 ? ata[0] : null;

        if (!declaracaoOriginal && !ataOriginal) {
            return declaracaoAtual && ataAtual;
        }

        const declaracaoAlterada = ficheiroFoiAlterado(declaracaoAtual, declaracaoOriginal);
        const ataAlterada = ficheiroFoiAlterado(ataAtual, ataOriginal);

        return declaracaoAlterada || ataAlterada;
    };

    const botaoHabilitado = () => {
        const declaracaoAtual = declaracao.length > 0;
        const ataAtual = ata.length > 0;

        if (!declaracaoAtual || !ataAtual) {
            return false;
        }

        return existemAlteracoes();
    };

    const guardar = () => {
        setLoading(true);

        const declaracaoAtual = declaracao.length > 0 ? declaracao[0] : null;
        const ataAtual = ata.length > 0 ? ata[0] : null;

        const declaracaoAlterada = ficheiroFoiAlterado(declaracaoAtual, declaracaoOriginal);
        const ataAlterada = ficheiroFoiAlterado(ataAtual, ataOriginal);

        var item = new FormData();
        item.append("turmaId", localStorage.getItem("codigo_curso"));
        item.append("code", code);

        if (declaracaoAlterada) {
            item.append("declaracao", declaracao[0]);
        }

        if (ataAlterada) {
            item.append("ata", ata[0]);
        }

        axios({
            method: "post",
            url: "/api/aproveitamento/aprovar-busca-ativa",
            data: item
        })
            .then(() => {
                openNotificationWithIcon("success", "Sucesso", "Aluno aprovado.");
                onConfirm();
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", error?.response?.data || "Ocorreu um erro ao aprovar o aluno.");
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const { getFieldDecorator } = form;

    const afterVisibleChange = visible => {
        if (!visible) {
            form.resetFields();
            limparEstados();
        }
    };

    useEffect(() => {
        if (visible && code) {
            limparEstados();
            detalhe();
        }
    }, [visible, code]);

    return (
        <>
            <Drawer
                title={
                    <div>
                        <div style={{ fontWeight: "bold", fontSize: 16, marginBottom: 10 }}>Aprovação de Aluno (Busca Ativa)</div>
                        <div style={{ fontSize: 12, color: "#888", lineHeight: "normal" }}>
                            Anexe os documentos necessários para aprovar o aluno no ano letivo, conforme os critérios da Busca Ativa.
                        </div>
                    </div>
                }
                className="drawer-inscrever"
                width={720}
                onClose={onClose}
                visible={visible}
                style={{
                    overflow: "auto",
                    height: "calc(100% - 108px)",
                    paddingBottom: "108px"
                }}
                maskClosable={false}
                afterVisibleChange={afterVisibleChange}
            >
                <div className="bloco-drawer-associar">
                    <Form className="form-emitir-declaracao">
                        <UploadAnexo
                            required
                            titulo="Declaração"
                            getFieldDecorator={getFieldDecorator}
                            fileList={declaracao}
                            setFileList={setDeclaracao}
                            form={form}
                            maxFileSize={FILE_SIZE.TEN_MB}
                            temExcluir
                        />
                        <UploadAnexo
                            required
                            titulo="Ata"
                            getFieldDecorator={getFieldDecorator}
                            fileList={ata}
                            setFileList={setAta}
                            form={form}
                            maxFileSize={FILE_SIZE.TEN_MB}
                            temExcluir
                        />
                    </Form>
                </div>
                <div className="ant-drawer-footer">
                    <button className="botao-secundario" onClick={onClose} style={{ marginRight: 20, display: "inline-block" }}>
                        Voltar
                    </button>
                    <button className="botao-principal" type="primary" disabled={loading || !botaoHabilitado()} onClick={guardar}>
                        {loading ? <Icon type="loading" /> : null}
                        Aprovar
                    </button>
                </div>
            </Drawer>
        </>
    );
};

const FormDrawerBuscaAtiva = Form.create({ name: "drawer-busca-ativa" })(DrawerBuscaAtiva);

export default FormDrawerBuscaAtiva;
